module.exports = __webpack_public_path__ + "static/media/bjc.d475a73f.jpg";